import { render, staticRenderFns } from "./surveyList.vue?vue&type=template&id=364d6b1c&scoped=true&"
import script from "./surveyList.vue?vue&type=script&lang=js&"
export * from "./surveyList.vue?vue&type=script&lang=js&"
import style0 from "./surveyList.vue?vue&type=style&index=0&id=364d6b1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d6b1c",
  null
  
)

export default component.exports